import React, { memo } from 'react';

const SafetyInfo = ({ safety }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">⚠️ Beach Safety</h2>
      
      <div className="bg-white/90 dark:bg-gray-800/90 backdrop-blur rounded-lg shadow-md p-4 border border-orange-100 dark:border-gray-700">
        <h3 className="font-semibold text-lg mb-3 dark:text-gray-100">🏖️ Beach Flag System</h3>
        <div className="space-y-2">
          {safety.beachFlags.map((flag, idx) => (
            <div key={idx} className="flex items-center space-x-3">
              <span className="text-2xl">{flag.color.split(' ')[0]}</span>
              <span className="text-sm text-gray-900 dark:text-gray-200">{flag.meaning}</span>
            </div>
          ))}
        </div>
        
        <div className="mt-4 pt-4 border-t border-orange-200 dark:border-gray-600">
          <h4 className="font-semibold mb-2 dark:text-gray-100">Flag Locations</h4>
          <ul className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
            {safety.flagLocations.map((location, idx) => (
              <li key={idx} className="text-gray-900 dark:text-gray-200">• {location}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="bg-red-50/90 dark:bg-red-900/20 backdrop-blur rounded-lg p-4 border border-red-200 dark:border-red-800">
        <h3 className="font-semibold text-lg mb-3 dark:text-gray-100">🌊 Rip Current Survival</h3>
        <p className="text-sm text-gray-900 dark:text-gray-200 mb-3">
          If caught in a rip current:
        </p>
        <ul className="space-y-2">
          {safety.ripCurrents.map((tip, idx) => (
            <li key={idx} className="text-sm text-gray-900 dark:text-gray-200">
              {idx < 2 ? '❌' : '✅'} {tip}
            </li>
          ))}
        </ul>
        
        <div className="mt-4 p-3 bg-red-100 dark:bg-red-900/30 rounded border border-red-300 dark:border-red-700">
          <p className="text-sm font-semibold text-red-800 dark:text-red-200">
            Recent fatality on June 9, 2025. No lifeguards on CSB beaches.
          </p>
        </div>
      </div>
    </div>
  );
};

export default memo(SafetyInfo);